module.exports = __webpack_public_path__ + "img/68_51.49bbd15f.png";